@include host-component-properties;

:host {
  display: block;
  position: relative;

  --paf-autocomplete-input-height: 73;
  --paf-autocomplete-background-color: #fff;
  --paf-box-shadow-color: rgb(0 0 0 / 40%);
  --paf-box-shadow-blur: 4;
}

.autocomplete {
  position: relative;
  background-color: var(--paf-autocomplete-background-color);
}

.list {
  box-shadow: var(--paf-box-shadow-color) 0 0 px-to-rem(var(--paf-box-shadow-blur)) 0;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: inherit;
  cursor: default;
  position: absolute;
  display: none;
  inset-block-start: px-to-rem(var(--paf-autocomplete-input-height));
  inset-inline: 0;
  background-color: var(--paf-autocomplete-background-color);
  z-index: 5;

  @include forced-colors {
    background-color: Canvas;
    border: px-to-rem(var(--paf-global-border-width-2x)) solid CanvasText;
    border-block-start: none;
  }

  &--visible {
    display: flex;
    flex-direction: column;
  }
}

.accessibility-hint {
  @include screen-reader-only;
}
